import { ChevronsUpDown, SquarePen, Trash } from "lucide-react";
import React, { useState } from "react";
import { can_visit, insurance_name } from "../../helpers";
import Badge from "../UI/Badge";
import DeleteModal from "../Modal/DeleteModal";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
  width: '230px'
};

export default function InsurancesDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    setEditGroupModalOpen = () => {},
    setGroupEditData = () => {},
    handleDeleteRecord = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
  } = props;

  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);
  const [orderBy, setOrderBy] = useState();

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };


  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th
                onClick={() => {
                  handleOrderChange("last_name");
                }}
                className={orderBy === "last_name" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Group Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>Insurances</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>

                    <td className="pointer" style={{ maxWidth: "250px" }}>
                      {item?.name}
                    </td>

                    <td className="pointer">
                      {item?.insurance_ids?.map((item, index) => (
                        <span key={index} className='docpro_fs_12 mr-1' style={{ display: "inline-flex", marginBottom: '2px' }}>
                          <Badge color="blue">{insurance_name(item)}</Badge>
                        </span>
                      ))}
                    </td>

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns">
                        {can_visit('administrator_insurance_group') && (
                          <button
                            type="button"
                            className="docpro_icon_btn last_btn_tip"
                            onClick={() => {
                              setEditGroupModalOpen(true);
                              setGroupEditData(item);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <SquarePen width={20} height={20} />
                            <span className="docpro_tip">Edit</span>
                          </button>
                        )}
                        {can_visit('administrator_insurance_group') && (
                          <button
                            type="button"
                            className="docpro_icon_btn docpro_icon_btn_red last_btn_tip"
                            onClick={() => {
                              setDeleteRecord(item);
                              setActiveDeleteModal(true);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <Trash width={20} height={20} />
                            <span className="docpro_tip">Delete</span>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="3">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="3">
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.name}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
